import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import properties from '../../../../modules/ajio-util/properties';
import * as actions from '../../../../actions/productData';
import { isCatalogNameInFirebaseStore } from '../../../../utils/common';
import { getStoresForHidingMRP } from '../../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../../../src/utils/imageHandling';

class ShopTheLook extends React.Component {
  constructor(props) {
    super(props);
  }

  openModal(prodData, e) {
    if (e) e.preventDefault();
    this.props.openModal(prodData);
  }

  render() {
    const { product = {}, storesForHidingMRP } = this.props;
    const { products = {}, ensembleLongTitle = '' } = product;
    const data = Object.keys(product).length === 0 ? '' : product;
    if (Object.keys(data).length === 0 || Object.keys(products).length === 0) {
      return null;
    }
    let ensambleProd = product.products;
    return (
      <div className="comp-section shop-the-look" id="ensamble">
        <h4 className="align-center">
          <span>{ensembleLongTitle.toLowerCase()}</span>
        </h4>
        <DataList
          storesForHidingMRP={storesForHidingMRP}
          data={ensambleProd}
          openModal={this.openModal.bind(this)}
        />
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 5) {
    arrow = 'none';
  }
  return (
    <div
      className={className}
      style={{ display: arrow, textAlign: 'center', zIndex: 1 }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 5) {
    arrow = 'none';
  }
  return (
    <div
      className={className}
      style={{ display: arrow, textAlign: 'center', zIndex: 1 }}
      onClick={onClick}
    />
  );
}

class DataList extends React.Component {
  render() {
    let ensamble = '';
    let addClass = '';
    let slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      lazyLoad: true,
      lazyLoadOffset: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    if (this.props.data.length < 4) {
      addClass = 'small-centered columns';
    }
    const { storesForHidingMRP } = this.props;
    var dataListItems = this.props.data.map((data, index) => {
      let image = data.fnlColorVariantData.outfitPictureURL;
      let { colorGroup } = data.fnlColorVariantData;
      const { catalogName } = data;
      const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
      return (
        <Col key={index} className={addClass}>
          <a href={data.url} className="prod-sec">
            <div className="sec-prod-disp">
              <img className="sec-img" src={`${replaceWithJioCDN(image)}`} width="204px" height="256px" />

              {data.fnlColorVariantData.exclusiveTill ? (
                <div className="sec-prod-exclusive" aria-label="EXCLUSIVE">EXCLUSIVE</div>
              ) : (
                ''
              )}
              {data.fnlColorVariantData.allPromotions ? <div className="sec-prod-offer" /> : ''}

              <div
                id="quickview"
                className="prod-quickview"
                onClick={this.props.openModal.bind(this, colorGroup)}
              >
                <span>QUICK VIEW</span>
              </div>
            </div>

            <div className="sec-product-details">
              <div className="sec-prod-title" aria-label={data.fnlColorVariantData.brandName}>{data.fnlColorVariantData.brandName}</div>
              <div className="sec-prod-subtitle" aria-label={data.name}>{data.name}</div>
              {data.price && data.price.displayformattedValue ? (
                <div className="sec-prod-cp">{data.price.displayformattedValue}</div>
              ) : (
                ''
              )}

              {data.wasPriceData &&
              data.wasPriceData.value &&
              data.wasPriceData.value > data.price.value &&
              hideMRP ? (
                <div className="sec-prod-price">
                  <span className="sec-prod-sp">
                    <span>{data.wasPriceData.displayformattedValue}</span>
                  </span>
                  &nbsp;
                  <span className="discount-percent">&nbsp;({data.discountPercent})</span>
                </div>
              ) : (
                ''
              )}
            </div>
          </a>
        </Col>
      );
    });

    if (this.props.data.length > 4) {
      ensamble = (
        <Slider {...slickSettings} ref="slick">
          {dataListItems}
        </Slider>
      );
    } else {
      ensamble = <Row className="center">{dataListItems}</Row>;
    }

    return <div>{ensamble}</div>;
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    product: state.product.ensamble,
    storesForHidingMRP: getStoresForHidingMRP(state)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  let productId = ownProps.productCode;
  return {
    fetchData: setTimeout(function() {
      dispatch(actions.getEnsamble(productId));
    }, 500),
    openModal: productId => dispatch(actions.openModal(productId))
  };
};

export default ShopTheLook = connect(mapStateToProps, mapDispatchToProps)(ShopTheLook);
